import { render, staticRenderFns } from "./rename-bucket.html?vue&type=template&id=6488d684&scoped=true&external"
import script from "./rename-bucket.js?vue&type=script&lang=js&external"
export * from "./rename-bucket.js?vue&type=script&lang=js&external"
import style0 from "./rename-bucket.scss?vue&type=style&index=0&id=6488d684&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6488d684",
  null
  
)

export default component.exports